import './globals.js';
import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './components/App';
import * as serviceWorker from './serviceWorker';
import './version.js';
import './useRDP.js';
import './index.css';
import { CoreUIProvider } from '@v2cloud/react';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CoreUIProvider>
      <App />
    </CoreUIProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();